import { PERMS } from '@/config/permissions';

// 后端权限名到前端 PERMS 常量的映射
// 请按需补充；如果后端与前端命名一致，则可保持一一对应
export const BACKEND_TO_PERMS: Record<string, string> = {
  // 示例映射：后端返回 EMPLOYEE_VIEW -> 前端 PERMS.USER_VIEW
  EMPLOYEE_VIEW: PERMS.USER_VIEW,
  EMPLOYEE_EDIT: PERMS.USER_EDIT,
  CUSTOMER_VIEW: PERMS.HOTEL_VIEW,
  CUSTOMER_EDIT: PERMS.HOTEL_EDIT,
  LINEN_VIEW: PERMS.LINEN_VIEW,
  LINEN_EDIT: PERMS.LINEN_EDIT,
  MILEAGE_SUBSIDY_VIEW: PERMS.MILEAGE_SUBSIDY_VIEW,
  MILEAGE_SUBSIDY_EDIT: PERMS.MILEAGE_SUBSIDY_EDIT,
  HANDLING_SUBSIDY_VIEW: PERMS.HANDLING_SUBSIDY_VIEW,
  HANDLING_SUBSIDY_EDIT: PERMS.HANDLING_SUBSIDY_EDIT,
  OPERATION_LOG_VIEW: PERMS.LOG_VIEW,
  // OPERATION_LOG_DELETE: PERMS.LOG_DELETE,
  COST_ALERT_RECORD_VIEW: PERMS.COST_WARNING_RECORD_VIEW,
  COST_ALERT_RECORD_EDIT: PERMS.COST_WARNING_RECORD_EDIT,
  COST_ALERT_THRESHOLD_VIEW: PERMS.COST_WARNING_THRESHOLD_VIEW,
  COST_ALERT_THRESHOLD_EDIT: PERMS.COST_WARNING_THRESHOLD_EDIT,
  LINEN_HANDOVER_VIEW: PERMS.TASK_HANDOVER_VIEW,
  TASK_VIEW: PERMS.TASK_MONITOR_VIEW,
  DELIVERY_TASK_TEMPLATE_VIEW: PERMS.TASK_TEMPLATE_VIEW,
  DELIVERY_TASK_TEMPLATE_EDIT: PERMS.TASK_TEMPLATE_EDIT,
  EXCEPTION_RECORD_VIEW: PERMS.TASK_EXCEPTION_VIEW,
  EXCEPTION_RECORD_EDIT: PERMS.TASK_EXCEPTION_HANDLE,
  RESET_PASSWORD: PERMS.USER_RESET_PASSWORD,
  APPROVAL_TEMPLATE_VIEW: PERMS.APPROVAL_FLOW_CONFIG_VIEW,
  APPROVAL_TEMPLATE_EDIT: PERMS.APPROVAL_FLOW_CONFIG_EDIT,
  APPROVAL_VIEW: PERMS.APPROVAL_RECORDS_VIEW,
  APPROVAL_EDIT: PERMS.APPROVAL_RECORDS_EDIT,
  SALARY_VIEW: PERMS.SALARY_VIEW,
  SALARY_EDIT: PERMS.SALARY_CALCULATE,
  REPORT_VIEW: PERMS.REPORT_BUSINESS_VIEW,
  ROLE_VIEW: PERMS.ROLE_VIEW,
  TASK_REMINDER_CONFIG_VIEW: PERMS.TASK_REMINDER_CONFIG_VIEW,
  TASK_REMINDER_CONFIG_EDIT: PERMS.TASK_REMINDER_CONFIG_EDIT,
  ROLE_EDIT: PERMS.ROLE_EDIT,
  HOTEL_LINEN_VIEW: PERMS.HOTEL_LINEN_VIEW,
  HOTEL_LINEN_EDIT: PERMS.HOTEL_LINEN_EDIT,
};

/**
 * 将后端权限字符串列表规范化为前端 PERMS 值列表；
 * 未映射的权限将原样保留以避免丢失。
 */
export function normalizePerms(list: string[]): string[] {
  return (list || []).map((p) => BACKEND_TO_PERMS[p] ?? p);
}
